import React, {FC} from "react"
import {Body} from "@irati/ui/src/Typography"

interface RenderProps {
  showText: string
}

interface Props {
  renderProps: RenderProps
}

export const AccordionHeader: FC<Props> = ({renderProps: {showText}}) => (
  <Body margin={2} weight="bold">
    {showText}
  </Body>
)
